// extracted by mini-css-extract-plugin
export default {"layout":"Blogs_layout__lI1wS","main":"Blogs_main__R7BMO","sidebar":"Blogs_sidebar__GJy-I"};